import React from 'react';

import { styled } from 'styled-components';

import Link from 'components/Link';

import { useFetchArticles } from 'hooks/queries/useFetchArticles';

import { buildBreadcrumbUrls } from 'utils/functions';

const MoreArticlesContainer = styled.div`
  height: 100%;
  grid-column-gap: 0rem;
  grid-row-gap: 1rem;
  flex-direction: column;
  grid-template-columns: 1fr;
  grid-auto-columns: 1fr;
  align-content: start;
  display: flex;
`;

const AnotherArticle = styled.div`
  padding-bottom: 1rem;
  border-bottom: solid 1px ${(props) => props.theme.colors.secondaryGray2};
`;

const ArticleTitleLink = styled(Link)`
  color: inherit;
  font-weight: 600;
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.colors.primaryRed};
  }
`;

interface MoreArticlesProps {
  featuredArticleId: string;
}

const MoreArticles = ({ featuredArticleId }: MoreArticlesProps) => {
  const { filteredRecentArticles } = useFetchArticles({ featuredArticleId });

  return (
    <MoreArticlesContainer>
      {filteredRecentArticles.map((article, i) => (
        <AnotherArticle key={i}>
          <ArticleTitleLink to={buildBreadcrumbUrls(article.breadcrumb, article.url)}>{article.title}</ArticleTitleLink>
        </AnotherArticle>
      ))}
    </MoreArticlesContainer>
  );
};

export default MoreArticles;
